<template>
    <el-carousel :height="bannerHeight">
        <el-carousel-item v-for="item in list" :key="item.id">
            <div @click="$openUrl(item.jump_url)" class="bannerItem">
                <template v-if="item.type == 1">
                    <img class="itemImage" :src="item.url" alt="" />
                </template>
                <template v-else>
                    <video class="itemImage" :src="item.url" muted loop :ref="'video' + index"
                        :poster="item.url + '?x-oss-process=video/snapshot,t_1000,m_fast'"></video>
                </template>
                <div class="textBox">
                    <div class="textCenter">
                        <div v-for="(item2, index2) in item.other.bigTitle" :key="index2" class="bigTitle">
                            {{ item2.title }}
                        </div>
                        <div v-for="(item2, index2) in item.other.smallTitle" :key="item2.title" class="smallTitle">
                            {{ item2.title }}
                        </div>
                    </div>
                </div>
            </div>
        </el-carousel-item>
    </el-carousel>
</template>

<script>
export default {
    components: {

    },
    props: {
        height: {
            type: String,
            default: '800px',
        }
    },
    data() {
        return {
            list: [],
            bannerHeight: '800px',
        }
    },
    mounted() {
        this.setHeight();
        window.addEventListener('resize', this.setHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.setHeight);
    },
    methods: {
        setHeight() {
            const w = window.innerWidth || document.documentElement.clientWidth;
            this.bannerHeight = w <= 1200 ? (w * 0.56) + 'px' : this.height;
        },
        setList(e) {
            this.list = e
        }
    }
}
</script>

<style scoped lang="scss">
.bannerItem {
    width: 100%;
    height: 100%;
    position: relative;
    cursor: pointer;

    .itemImage {
        width: 100%;
        object-fit: cover;
        height: 100%;
    }

    .textBox {
        width: 1200px;
        height: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);

        .textCenter {
            position: absolute;
            left: 0;
            top: 50%;
            transform: translate(0, -50%);

            .bigTitle {
                width: 1200px;
                margin: auto;
                font-weight: 500;
                font-size: 40px;
                color: #FFFFFF;
                line-height: 60px;
            }

            .smallTitle {
                max-width: 400px;
                margin-top: 28px;
                font-weight: 300;
                font-size: 18px;
                color: #FFFFFF;
                line-height: 24px;
            }
        }
    }
}

::v-deep .el-carousel__arrow--left {
    display: none !important;
}

::v-deep .el-carousel__arrow--right {
    display: none !important;
}

::v-deep .el-carousel__item.is-animating {
    transition: transform 1s ease-in-out;
}

@media screen and (max-width:1200px) {
    .bannerItem {
        background: #000;

        .itemImage {
            object-fit: cover;
        }

        .textBox {
            width: 100%;
            box-sizing: border-box;
            padding: 0 15px;

            .textCenter {
                left: 15px;
                right: 15px;

                .bigTitle {
                    width: 100%;
                    font-size: 22px;
                    line-height: 30px;
                }

                .smallTitle {
                    max-width: 100%;
                    margin-top: 14px;
                    font-size: 14px;
                    line-height: 20px;
                }
            }
        }
    }
}
</style>
